/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Analysis_In_Progress_TitleInputs */

const en_case_detail_analysis_in_progress_title = /** @type {(inputs: Case_Detail_Analysis_In_Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis in progress`)
};

const pt_br2_case_detail_analysis_in_progress_title = /** @type {(inputs: Case_Detail_Analysis_In_Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em análise`)
};

/**
* | output |
* | --- |
* | "Analysis in progress" |
*
* @param {Case_Detail_Analysis_In_Progress_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_analysis_in_progress_title = /** @type {((inputs?: Case_Detail_Analysis_In_Progress_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Analysis_In_Progress_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_analysis_in_progress_title(inputs)
	return pt_br2_case_detail_analysis_in_progress_title(inputs)
});